import React, { useState, useRef, useCallback, useEffect } from 'react';
import { translate } from '../services/AppService';
import Button from './Button';
import Dialog from './PublicDialogs/Dialog'

interface CameraState {
    isActive: boolean;
    statusMessage: string;
}

export default function CameraCapture(props: { show?: boolean, onClose?: () => void, onImageCaptured: (imag: string) => void }) {

    const [cameraState, setCameraState] = useState<CameraState>({
        isActive: false,
        statusMessage:""
    });

    const videoRef = useRef<HTMLVideoElement>(null);
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const streamRef = useRef<MediaStream | null>(null);

    const startCamera = useCallback(async () => {
        try {
            const constraints: MediaStreamConstraints = {
                video: {
                    facingMode: 'user',
                    width: { ideal: 1280 },
                    height: { ideal: 720 }
                }
            };

            const stream = await navigator.mediaDevices.getUserMedia(constraints);
            streamRef.current = stream;

            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }

            setCameraState(prev => ({
                ...prev,
                isActive: true,
                statusMessage: ''
            }));
        } catch (error) {
            console.error('خطأ في الوصول للكاميرا:', error);
            setCameraState(prev => ({
                ...prev,
                statusMessage: 'خطأ: لم نتمكن من الوصول للكاميرا'
            }));
        }
    }, []);

    const stopCamera = useCallback(() => {
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(track => track.stop());
            streamRef.current = null;
        }

        if (videoRef.current) {
            videoRef.current.srcObject = null;
        }

        setCameraState(prev => ({
            ...prev,
            isActive: false
        }));
    }, []);

    const toggleCamera = useCallback(() => {
        if (cameraState.isActive) {
            stopCamera();
        } else {
            startCamera();
        }
    }, [cameraState.isActive, startCamera, stopCamera]);

    const capturePhoto = useCallback(() => {
        if (!videoRef.current || !canvasRef.current) return;

        const video = videoRef.current;
        const canvas = canvasRef.current;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
            setCameraState(prev => ({
                ...prev,
                statusMessage: 'خطأ: لا يمكن الوصول إلى Canvas'
            }));
            return;
        }

        ctx.drawImage(video, 0, 0);
        const imageData = canvas.toDataURL('image/png');
        console.log("imageData", imageData)
        props.onImageCaptured(imageData)
    }, []);

    useEffect(() => {
        if (props.show)
            toggleCamera();
        else
            stopCamera()
    }, [props.show])

    return (

        <Dialog show={props.show} size="md" onClose={props.onClose} okLabel="TakePicture"
            ok={() => capturePhoto()}>
            <div className="min-h-screen bg-gradient-to-br from-purple-600 to-purple-900 flex items-center justify-center">
                <div className="bg-white rounded-3xl  shadow-2xl max-w-2xl w-full">
                    <div className="relative w-100 bg-black rounded-xl overflow-hidden ">
                        <video ref={videoRef} autoPlay playsInline className="w-100 " />
                        <canvas ref={canvasRef} className="d-none" />
                    </div>
                </div>
                {cameraState.statusMessage &&<div className="text-center text-gray-600 text-sm mb-6">
                    {cameraState.statusMessage}
                </div>}
            </div>

        </Dialog>
    );
};
